module.exports = __webpack_public_path__ + "img/Priest-undead-f-70.430a2520.gif";